var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HeaderPanel"},[_c('div',{staticClass:"HeaderPanel__list"},_vm._l((_vm.list),function(ref,index){
var name = ref.name;
var text = ref.text;
var param = ref.param;
var secondary = ref.secondary;
var icon = ref.icon;
return _c('div',{key:index,class:[
                    'HeaderPanel__item',
                    {'HeaderPanel__item--secondary': secondary},
                    {'HeaderPanel__item--active': _vm.isObjectsPage && _vm.globalFilter === param}
                    ],on:{"click":function($event){return _vm.setFilter(param)}}},[_c(icon,{tag:"component",staticClass:"HeaderPanel__icon hide-tablet-only"}),_c('div',{staticClass:"HeaderPanel__info"},[_c('div',{staticClass:"HeaderPanel__text"},[_vm._v(_vm._s(name))]),_c('div',{staticClass:"HeaderPanel__amount"},[_vm._v(_vm._s(text))])])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }